// Vendor
import { defineStore } from 'pinia'

// Personal libs
import UpdateManagerState from './state'
import { IStoreUpdateManagerState } from './update-manager.interface'

export const useUpdateManagerStore = defineStore('updateManager', {
  state: (): IStoreUpdateManagerState => ({ ...UpdateManagerState }),
  actions: {
  }
})
